import { Link } from './Link';
import { withLinks, removeLinkMark } from './utils';

const LinkPlugin = ({ className, LINK_TAG, ...attributes } = {}) => ({
  renderElement: Link({ className, LINK_TAG, ...attributes }),
  onKeyDown: (event, editor) => {
    removeLinkMark(event, editor);
  },
  with: withLinks,
});

export { LinkPlugin };
